import { brPost } from '../brRequestWrapper';
import { ApiRoutes } from '../apiRoutes';

export const updateBulkInvoiceCollectionStatus = async (invoices: any) => {
  const response = await brPost(ApiRoutes.UpdateBulkInvoiceCollectionStatus, invoices);
  return response.data;
};
